// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"4276a398","341":"732cc7db","392":"1a804231","602":"f5c43ac3","717":"c7cbe307","728":"b05c1502","778":"22379526","804":"c10d34d3","834":"f1f16082","908":"8c308783","970":"b59d43bd"}[chunkId] + ".chunk.js";
};